import { Flex, ResourceList } from "@wayflyer/flyui";
import type { IntlShape } from "react-intl";
import { useIntl } from "react-intl";
import type { KYCAirSchema } from "shared-ui";
import { useSpaNavigate } from "shared-ui";

import { InfoSection } from "../info-section";

import { getAirResourceItems } from "./get-air-resource-items";

interface KYCAirsProps {
  kycAirs: KYCAirSchema[];
  hideHeader?: boolean;
}

export const KYCAirsComponent = ({ kycAirs, hideHeader = false }: KYCAirsProps) => {
  const intl = useIntl();

  return (
    <Flex direction="column" gap="8">
      {!hideHeader && (
        <InfoSection
          heading={intl.formatMessage({
            id: "KYC AIRs: Provide additional information",
            defaultMessage: "Provide additional information",
          })}
          content={[
            intl.formatMessage({
              id: "KYC AIRs: We need additional information about your business or its beneficial owners to move forward with your application.",
              defaultMessage:
                "We need additional information about your business or its beneficial owners to move forward with your application.",
            }),
          ]}
        />
      )}
      <KYCAIRsList kycAirs={kycAirs} intl={intl} />
    </Flex>
  );
};

const KYCAIRsList = ({ kycAirs, intl }: { kycAirs: KYCAirSchema[]; intl: IntlShape }) => {
  const { navigate } = useSpaNavigate("VerifyBusiness");

  const goToAirScreen = (airId: string) => {
    navigate(`/additional-information-request/${airId}`);
  };

  const airResourceItems = getAirResourceItems(intl, kycAirs, goToAirScreen);

  return airResourceItems.length ? (
    <Flex direction="column" gap="3">
      <ResourceList hideFinalDivider>
        {airResourceItems.map((item) => (
          <ResourceList.NavigationActionItem key={item.id} {...item} />
        ))}
      </ResourceList>
    </Flex>
  ) : null;
};
